/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { bool, shape } from "prop-types";
import { Formik } from "formik";
import {  Row } from "react-bootstrap";
import * as i18n from "util/i18n";
import { actions as thirdPaymentActions, selectors as thirdPaymentSelectors } from "reducers/thirdPayment";
import GridTable from "pages/_components/GridTable/GridTable";
import { ResponsiveHeader } from "pages/_components/header";
import MainContainer from "pages/_components/MainContainer";
import Notification from "pages/_components/Notification";
import CustomData from "pages/_components/CustomData/CustomData";
import { push } from "connected-react-router";
import * as numberUtils from "util/number";
import FormattedAmount from "pages/_components/FormattedAmount";
import GeneralCredentialForm from "pages/_components/Forms/GeneralCredentialForm";

const PayrollConfirm = (props) => {
    const { isDesktop, documentToConfirm, fetching, fileId } = props;
    const [requestBody, setRequestBody] = useState(false);
    const dispatch = useDispatch();

    const onBack = () => {
        if (documentToConfirm?.idTransaction)
            dispatch(push(`/massPayroll/transaction/${documentToConfirm?.idTransaction}`));
        else  {
            dispatch(push("/massPayroll",  { isConfirm: true, tab: 0}));
       }

    };

    useEffect(() => {
         setRequestBody({
            idTransaction: documentToConfirm?.idTransaction,
            documentName:  documentToConfirm?.documentName,
            totalRecords: documentToConfirm?.totalRecords,
            totalAmount: documentToConfirm?.totalAmount,
            fileId: fileId,
        });
    }, []);
    
    return (
        <>
            <Notification scopeToShow="PayrollConfirm" />
            <ResponsiveHeader
                id={`payroll.title`}
                onClickBack={onBack}
                defaultTitle={i18n.get(`payroll.title`)}
            />
            <MainContainer >
                <h2>{i18n.get(`payroll.confirm.title`)}</h2>
                <GridTable className="form-summary grid-table-form">
                    <GridTable.Container>
                        <GridTable.Data columnStart={1} rowStart={1} >
                             <CustomData
                                    titleText={i18n.get(`payroll.loadRequest.filename.label`)}
                                    titleTextType="TEXT"
                                    valueTextType="TEXT"
                                    valueText={documentToConfirm?.documentName}
                                />
                        </GridTable.Data>
                        <GridTable.Data
                            columnStart={isDesktop ? 2 : 1}
                            rowStart={isDesktop ? 1 : 2}
                            >
                             <CustomData
                                    titleText={i18n.get(`payroll.loadRequest.totalRecords.label`)}
                                    titleTextType="TEXT"
                                    valueTextType="TEXT"
                                    valueText={documentToConfirm?.totalRecords}
                                />
                        </GridTable.Data>
                         <GridTable.Data
                            columnStart={isDesktop ? 3 : 1}
                            rowStart={isDesktop ? 1 : 2}
                            >
                             <CustomData
                                    titleText={i18n.get(`payroll.loadRequest.totalAmount.label`)}
                                    titleTextType="TEXT"
                                    valueTextType="TEXT"
                                    valueText={<FormattedAmount
                                        currency="ARS"
                                        quantity={numberUtils.formatAmountStrDouble(
                                            documentToConfirm?.totalAmount,
                                        )}
                                    />}
                                />
                        </GridTable.Data>
                    </GridTable.Container>
                </GridTable>

                 <Formik
                    validateOnBlur
                    validateOnChange={false}
                    initialValues={{
                        credential: "",
                        termAndConditions: false,
                    }}
                    >
                    {() => (
                        <>
                            <Row>
                                <GeneralCredentialForm
                                    transactionData={requestBody}
                                    type="otp"
                                    action={thirdPaymentActions.payrollSend}
                                    idActivity="payroll.send"
                                    hideIndications
                                    disableContinueIfEmpty
                                />
                            </Row>
                            </>
                    )}
                </Formik>
            </MainContainer>
        </>
    );
};

PayrollConfirm.propTypes = {
    isDesktop: bool.isRequired,
    servicePaymentData: shape({}).isRequired,
};
const mapStateToProps = (state) => ({
    documentToConfirm: thirdPaymentSelectors.getDocumentToConfirm(state),
    fetching: thirdPaymentSelectors.isPayrollFetching(state),
    fileId: thirdPaymentSelectors.getPayrollFileId(state),
});
export default connect(mapStateToProps)(PayrollConfirm);


